import { Component } from 'preact';
import { RADIUS } from '../../lib/medievalTheme';

/**
 * Transparent token preview that follows the cursor while the player
 * is placing a summon (v1.88 SUMMON_TOKEN_AT_LOCATIONS click flow).
 *
 * Pure presentational. Listens to window mousemove and renders a
 * fixed-position image at the cursor. The host (GameBoard) decides
 * when to mount the component by passing `imageUrl` (null = hidden).
 *
 * Per the global UI-scale architecture (see CLAUDE.md), this is a
 * `position: fixed` element inside `.app-canvas` and uses cqw sizing
 * so it scales with the canvas. Card dimensions match the in-play
 * card geometry: 6.875cqw wide × 9.625cqw tall (roughly 110×154 px on
 * a 1600 design canvas at scale 1).
 */
export default class TokenSpawnPreview extends Component {
  constructor(props) {
    super(props);
    this.state = { x: 0, y: 0, visible: false };
  }

  componentDidMount() {
    window.addEventListener('mousemove', this.handleMouseMove);
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove);
  }

  handleMouseMove = (e) => {
    // Convert viewport coords to canvas-local coords so the preview
    // letterboxes correctly with the rest of the .app-canvas content.
    const canvas = document.querySelector('.app-canvas');
    if (!canvas) {
      this.setState({ x: e.clientX, y: e.clientY, visible: true });
      return;
    }
    const rect = canvas.getBoundingClientRect();
    this.setState({
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
      visible: true,
    });
  };

  render() {
    const { imageUrl, name } = this.props;
    if (!imageUrl) return null;
    const { x, y, visible } = this.state;
    if (!visible) return null;
    return (
      <div
        aria-hidden="true"
        style={{
          position: 'fixed',
          left: `${x}px`,
          top: `${y}px`,
          width: '6.875cqw',
          height: '9.625cqw',
          // Anchor center on cursor + lift slightly so the cursor is
          // still visible at the card's bottom-center.
          transform: 'translate(-50%, -50%)',
          opacity: 0.65,
          pointerEvents: 'none',
          zIndex: 9999,
          borderRadius: RADIUS.card,
          boxShadow: '0 0 1cqw 0.25cqw rgba(212, 175, 55, 0.55)',
          background: `url("${imageUrl}") center/cover no-repeat, #1a1a1a`,
        }}
        title={name}
      />
    );
  }
}
